import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/apiClient";

const AuthCtx = createContext({
  user: null,
  workspaces: [],
  login: () => {},
  register: () => {},
  logout: () => {},
  loading: true,
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!api.token()) {
      setUser(null);
      setWorkspaces([]);
      setLoading(false);
      return;
    }
    try {
      const me = await api.get("/api/auth/me");
      setUser(me.user);
      setWorkspaces(me.workspaces || []);
    } catch (_) {
      api.setToken(null);
      setUser(null);
      setWorkspaces([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const res = await api.post("/api/auth/login", { email, password });
    api.setToken(res.token);
    setUser(res.user);
    await refresh();
    return res.user;
  };

  const register = async ({ email, password, name, termsAccepted }) => {
    const res = await api.post("/api/auth/register", {
      email,
      password,
      name,
      terms_accepted: termsAccepted,
    });
    api.setToken(res.token);
    setUser(res.user);
    await refresh();
    return res.user;
  };

  const logout = () => {
    api.setToken(null);
    setUser(null);
    setWorkspaces([]);
  };

  return (
    <AuthCtx.Provider
      value={{ user, workspaces, login, register, logout, refresh, loading }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
